export enum SizeVarType{
  Small,
  Medium,
  Large
}
